// Stable anchor id helpers for footnote/endnote backref linking.
// Single source of truth shared by:
//   - TipTap node views (FootnoteRefNode, EndnoteRefNode) — add an id to the
//     in-text marker so the trailing "Notes" block ↩ can jump back to it.
//   - CitationsPreviewPanel — render bodies with `id={footnoteBodyId(id)}`
//     so clicking a marker scrolls down to the matching body entry.
//   - renderBriefDocument (render/inline.ts + render/blocks.ts) — published
//     HTML uses the exact same id scheme so the same anchors work post-export.
//
// Numbering is shared between footnoteRef + endnoteRef in document order (see
// render/document.ts), so a single `fn-` / `fnref-` prefix space is correct
// for both kinds.

export const footnoteBodyId = (id: string): string => `fn-${id}`;
export const footnoteRefId = (id: string): string => `fnref-${id}`;
